import gql from 'graphql-tag'

export const SEND_OTP = gql`
 mutation insert_sendOtp($mobile: bigint!,$uniqueId: uuid!) {
  insert_sendOtp(objects: {mobile: $mobile, uniqueId: $uniqueId}) {
    returning {
      id
      uniqueId
 }
}
  }
`
